// extracted by mini-css-extract-plugin
export default {"container":"container-XQJ8fGyl"};